export const COVER_SIZE = {minWidth: 1366, minHeight: 768};
